import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import FormButton from 'components/form-components/FormButton';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';

const ScheduleActions = ({ ids, actionsCallBack, isActionButton }) => {
  const { t } = useTranslation();

  const [actionsOptions, setActionsOptions] = useState([]);
  const [confirmModalProps, setConfirmModalProps] = useState(null);

  const isAllowedEdit = () => {
    return (
      ids.length === 1 &&
      (ids[0].status === 'draft' ||
        (ids[0].status === 'published' &&
          (ids[0].scheduleType === 'recurring' ||
            (ids[0].scheduleType === 'one_time' && new Date(ids[0].startDate) > new Date()))))
    );
  };

  useEffect(() => {
    const allOptions = [
      { value: 'edit', displayValue: 'select_edit', permission: isAllowedEdit() },
      {
        value: 'close',
        displayValue: 'select_close',
        permission: ids.length === 1 && ids[0].status === 'published',
      },
      {
        value: 'duplicate',
        displayValue: 'select_duplicate',
        permission: ids.length === 1 && ids[0].status === 'published',
      },
      { value: 'archive', displayValue: 'select_archive', permission: true },
      { value: 'delete', displayValue: 'select_delete', permission: true },
    ];

    const visibleOptions = allOptions.filter((option) => option.permission);

    setActionsOptions(visibleOptions);
  }, [ids.length]);

  const handleAction = (_, value) => {
    if (value === 'edit' || value === 'duplicate') actionsCallBack(value, { id: ids[0].id });
    else if (['close', 'archive', 'delete'].includes(value)) {
      setConfirmModalProps({
        type: value,
        title:
          value === 'close'
            ? 'alert_schedule_close_title'
            : value === 'archive'
            ? 'alert_schedule_archive_title'
            : 'alert_schedule_deletion_title',
        message:
          value === 'close'
            ? 'alert_schedule_close_message'
            : value === 'archive'
            ? 'alert_schedule_archive_message'
            : 'alert_schedule_deletion_message',
        text:
          value === 'close'
            ? 'button_close'
            : value === 'archive'
            ? 'button_archive'
            : 'button_delete',
      });
    }
  };

  const handleConfirmAction = () => {
    if (confirmModalProps.type === 'close')
      actionsCallBack(confirmModalProps.type, { id: ids[0].id });
    else if (confirmModalProps.type === 'archive' || confirmModalProps.type === 'delete')
      actionsCallBack(confirmModalProps.type, { ids: ids.map((i) => i.id) });

    setConfirmModalProps(null);
  };

  return (
    <>
      {confirmModalProps && (
        <ConfirmationModal
          show={!!confirmModalProps}
          title={t(confirmModalProps.title)}
          message={t(confirmModalProps.message)}
          actionList={[
            {
              color: 'black-1',
              text: t('button_cancel'),
              onClick: () => setConfirmModalProps(null),
            },
            {
              color: 'red-1',
              text: t(confirmModalProps.text),
              onClick: () => handleConfirmAction(),
            },
          ]}
        />
      )}
      <MultiLevelSelect
        options={{ children: actionsOptions }}
        value={[]}
        name='action'
        handleChange={(name, value) => handleAction(name, value[0])}
        toggleClasses=''
        toggleComponent={
          <>
            {isActionButton ? (
              <img className='cursor-pointer' src={dotsIcon} />
            ) : (
              <FormButton text='button_action' variant='green-1' icon={dropdownIcon} minWidth />
            )}
          </>
        }
        disabled={!ids.length || !actionsOptions.length}
      />
    </>
  );
};

ScheduleActions.propTypes = {
  ids: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
  isActionButton: PropTypes.bool.isRequired,
};

export default ScheduleActions;
